import { render, staticRenderFns } from "./ComplaintDocument.vue?vue&type=template&id=3a3480bc&"
import script from "./ComplaintDocument.vue?vue&type=script&lang=js&"
export * from "./ComplaintDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports